<template>

    <footer class="footer">

        <div class="container">

            <div class="footer__grid">

                <div class="footer__brand">

                    <router-link
                        :to="{
                            path: '/',
                            hash: '#hero'
                        }"
                        class="footer__logo"
                    >

                        <img
                            :src="'header_logo' | staticImg"
                            :alt="'header_logo' | staticTitle"
                        >

                    </router-link>

                    <p>
                        {{ 'footer_brand' | staticContent }}
                    </p>

                    <div class="footer__social">

                        <a
                            v-for="social in validSocialLinks"
                            :key="social.hash"
                            :href="social.url"
                            target="_blank"
                            rel="noopener noreferrer"
                            :aria-label="social.hash | staticTitle"
                        >

                            <i :class="social.icon"></i>

                        </a>

                    </div>

                </div>

                <div class="footer__column">

                    <h3>
                        {{ 'footer_contact' | staticTitle }}
                    </h3>

                    <vue-marked>
                        {{ 'footer_contact' | staticContent }}
                    </vue-marked>

                </div>

                <div class="footer__column">

                    <h3>
                        QUICK LINKS
                    </h3>

                    <nav class="footer__links">

                        <router-link
                            v-for="link in quickLinks"
                            :key="link.label"
                            :to="link.to"
                        >
                            {{ link.label }}
                        </router-link>

                    </nav>

                </div>

                <div class="footer__column">

                    <h3>
                        {{ 'footer_right' | staticTitle }}
                    </h3>

                    <vue-marked>
                        {{ 'footer_right' | staticContent }}
                    </vue-marked>

                </div>

            </div>

        </div>

        <div class="footer__bottom">

            <div class="container">

                <p>
                    {{ 'footer_bottom' | staticTitle }}
                </p>

                <div class="footer__legal">

                    <router-link to="/privacy-policy">
                        Privacy Policy
                    </router-link>

                    <span>|</span>

                    <router-link to="/terms-and-conditions">
                        Terms and Conditions
                    </router-link>

                    <span>|</span>

                    <router-link to="/cookies">
                        Cookies
                    </router-link>

                </div>

            </div>

        </div>

    </footer>

</template>

<script>
export default {
    name: 'navFooter',

    data() {
        return {
            quickLinks: [
                {
                    label: 'About',
                    to: {
                        path: '/',
                        hash: '#about'
                    }
                },
                {
                    label: 'Ministries',
                    to: {
                        path: '/',
                        hash: '#ministries'
                    }
                },
                {
                    label: 'Sermons',
                    to: {
                        name: 'Sermons'
                    }
                },
                {
                    label: 'Resources',
                    to: {
                        path: '/',
                        hash: '#resources'
                    }
                },
                {
                    label: 'Contact',
                    to: {
                        path: '/',
                        hash: '#contact'
                    }
                }
            ],

            socialLinks: [
                {
                    hash: 'footer_facebook',
                    icon: 'fa-brands fa-facebook-f'
                },
                {
                    hash: 'footer_instagram',
                    icon: 'fa-brands fa-instagram'
                },
                {
                    hash: 'footer_youtube',
                    icon: 'fa-brands fa-youtube'
                },
                {
                    hash: 'footer_whatsapp',
                    icon: 'fa-brands fa-whatsapp'
                }
            ]
        };
    },

    computed: {
        validSocialLinks() {
            return this.socialLinks
                .map(social => ({
                    ...social,
                    url: this.getSocialUrl(
                        social.hash
                    )
                }))
                .filter(
                    social =>
                        social.url
                );
        }
    },

    methods: {
        getSocialUrl(hash) {
            const url =
                this.$options.filters.staticContent(
                    hash
                );

            if (
                !url ||
                url.includes('-content')
            ) {
                return '';
            }

            return url.trim();
        }
    }
};
</script>

<style lang="scss" scoped>
.footer {
    background:
        #262626;

    color:
        #fff;

    text-align:
        center;

    .container {
        width:
            100%;

        max-width:
            500px;

        margin:
            0 auto;

        padding:
            60px 20px;
    }

    &__grid {
        display:
            grid;

        gap:
            45px;
    }

    &__brand {
        text-align:
            center;

        p {
            margin-bottom:
                25px;

            font-size:
                .95rem;

            line-height:
                1.7;

            color:
                #d6d6d6;
        }
    }

    &__logo {
        display:
            inline-block;

        img {
            display:
                block;

            width:
                170px;

            margin:
                0 auto
                20px;
        }
    }

    &__social {
        display:
            flex;

        justify-content:
            center;

        flex-wrap:
            wrap;

        gap:
            15px;

        a {
            width:
                38px;

            height:
                38px;

            display:
                flex;

            align-items:
                center;

            justify-content:
                center;

            border:
                1px solid
                rgba(
                    255,
                    255,
                    255,
                    .15
                );

            border-radius:
                50%;

            color:
                #fff;

            text-decoration:
                none;

            transition:
                background .3s ease,
                border-color .3s ease,
                transform .3s ease;

            &:hover {
                background:
                    var(--primary);

                border-color:
                    var(--primary);

                transform:
                    translateY(-2px);
            }
        }
    }

    &__column {
        text-align:
            center;

        h3 {
            margin-bottom:
                18px;

            font-family:
                'Poppins',
                sans-serif;

            font-size:
                .95rem;

            font-weight:
                600;

            color:
                #fff;
        }

        ::v-deep p {
            margin:
                0 0
                10px;

            color:
                #d3d3d3;

            font-size:
                .92rem;

            line-height:
                1.6;
        }

        ::v-deep ul {
            list-style:
                none;

            margin:
                0;

            padding:
                0;
        }

        ::v-deep li {
            margin-bottom:
                10px;

            color:
                #d3d3d3;

            font-size:
                .92rem;

            line-height:
                1.6;
        }

        ::v-deep a {
            color:
                #d3d3d3;

            text-decoration:
                none;

            transition:
                color .3s ease;

            &:hover {
                color:
                    var(--primary);
            }
        }
    }

    &__links {
        display:
            flex;

        flex-direction:
            column;

        align-items:
            center;

        gap:
            10px;

        a {
            color:
                #d3d3d3;

            font-size:
                .92rem;

            line-height:
                1.6;

            text-decoration:
                none;

            transition:
                color .3s ease,
                transform .3s ease;

            &:hover {
                color:
                    var(--primary);

                transform:
                    translateX(3px);
            }
        }
    }

    &__bottom {
        background:
            var(--primary);

        .container {
            max-width:
                500px;

            padding:
                18px 20px;

            display:
                flex;

            flex-direction:
                column;

            gap:
                12px;

            text-align:
                center;
        }

        p {
            margin:
                0;

            font-size:
                .82rem;

            color:
                #fff;
        }

        a {
            color:
                #fff;

            text-decoration:
                none;

            font-size:
                .82rem;

            &:hover {
                text-decoration:
                    underline;
            }
        }

        span {
            color:
                #fff;
        }
    }

    &__legal {
        display:
            flex;

        justify-content:
            center;

        align-items:
            center;

        flex-wrap:
            wrap;

        gap:
            10px;
    }
}

@media (min-width: 768px) {
    .footer {

        .container {
            max-width:
                1200px;
        }

        &__grid {
            grid-template-columns:
                1.4fr
                1fr
                1fr
                1fr;

            gap:
                50px;

            align-items:
                flex-start;
        }

        &__brand {
            display:
                flex;

            flex-direction:
                column;

            align-items:
                center;

            text-align:
                center;
        }

        &__links {
            align-items:
                center;
        }

        &__bottom {

            .container {
                max-width:
                    1200px;

                flex-direction:
                    row;

                justify-content:
                    space-between;

                align-items:
                    center;
            }
        }
    }
}
</style>